export default __webpack_public_path__ + "static/sublimation5-a873aa84048546da90bbb1db609e9a93.jpg";